<compartido-ficha [configuracion]="configFicha">
  <input
    (paste)="pegarFila($event)"
    class="paste-input"
    type="text"
    placeholder="Pega aquí una o más filas del Excel."
  />

  <compartido-tabla
    class="tabla"
    [configuracion]="configTabla"
    [datos]="filas"
    (clickAccion)="eliminarFila($event.fila)"
  ></compartido-tabla>

  <button
    mat-flat-button
    class="boton"
    color="primary"
    *ngIf="filas.length > 0"
    (click)="crearOrdenes$()"
  >
    Crear Órdenes
  </button>
</compartido-ficha>

<ordenes-imprimir-etiquetas class="imprimir" #imprimir>
</ordenes-imprimir-etiquetas>
